import { createFileRoute } from "@tanstack/react-router";

import { StylePage } from "@/features/style";

// «Стиль игры»: экран целиком из фичи `style`.
export const Route = createFileRoute("/style")({
  component: StylePage,
});
